// extracted by mini-css-extract-plugin
module.exports = {"menu":"Productmenu_menu__3jNE_"};